enum MessageStatus {
  unread = 'Unread',
  read = 'Read',
}

export default MessageStatus;
